import React, { useEffect, useRef } from 'react';

interface BottomAdProps {
  adsEnabled: boolean;
}

const BottomAd: React.FC<BottomAdProps> = ({ adsEnabled }) => {
  const adRef = useRef<HTMLDivElement>(null);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (adsEnabled && !hasInitialized.current && adRef.current) {
      try {
        // Check if adsbygoogle is available
        if (typeof window !== 'undefined' && (window as { adsbygoogle?: unknown[] }).adsbygoogle) {
          ((window as { adsbygoogle: unknown[] }).adsbygoogle = (window as { adsbygoogle: unknown[] }).adsbygoogle || []).push({});
          hasInitialized.current = true;
        }
      } catch (error) {
        console.error('Error loading bottom ad:', error);
      }
    }
  }, [adsEnabled]);

  // Don't render anything if ads are disabled
  if (!adsEnabled) {
    return null;
  }

  return (
<div className="w-full bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-6">
<div className="w-full max-w-3xl mx-auto p-4">
        <div ref={adRef} className="w-full">
          <ins 
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-2821204101106956"
            data-ad-slot="7209419874"
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
      </div>
    </div>
  );
};

export default BottomAd; 